import styled from "styled-components";
import { colors } from "../contants";

export const infoText = styled.h2`
  color: white;
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  position: relative;
  padding-bottom: 1rem;
  margin-bottom: 2.5rem;

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 56px;
    height: 3px;
    background: ${colors.gold};
    border-radius: 2px;
  }
`;

export const infoCont = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: clamp(4rem, 8vw, 5.5rem) 1.5rem;
  background-color: rgb(40, 40, 50);
`;

export const infoContainer = styled.div`
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 1.75rem;
`;

export const infoItem = styled.div`
  display: flex;
`;

export const infoCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2rem 1.25rem;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: transform 0.25s ease, background 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    background: rgba(255, 255, 255, 0.07);
  }
`;

export const StyledIcon = styled.div`
  width: 50px;
  height: 50px;
  background-repeat: no-repeat;
  background-size: contain;
  align-items: center;
`;

export const infoImg = styled.img`
  height: 100px;
  width: 100px;
`;

export const infoTitle = styled.h3`
  font-size: 0.9rem;
  letter-spacing: 0.06em;
  margin-top: 1.1rem;
  color: white;
  margin-bottom: 0.6rem;
  text-align: center;
`;

export const infoContent = styled.p`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.65);
  text-align: center;
  line-height: 1.5;
`;
